import { Point } from "./point";

export class Circle {
  #center: Point;
  #radius: number;

  get center() {
    return this.#center;
  }

  get x() {
    return this.#center.x;
  }

  get y() {
    return this.#center.y;
  }

  get radius() {
    return this.#radius;
  }

  constructor(center: Point, radius: number) {
    this.#center = center;
    this.#radius = radius;
  }

  addToRadius(value: number) {
    return new Circle(this.#center, this.radius + value);
  }

  intersect(other: Circle) {
    return circleIntersect(this, other);
  }

  isIntersecting(other: Circle) {
    return isIntersecting(this, other);
  }
}

export interface CircleOptions {
  x: number;
  y: number;
  radius: number;
}

export function createCircle(options: CircleOptions) {
  const center = new Point(options.x, options.y)
  return new Circle(center, options.radius);
}

export function isIntersecting(c1: Circle, c2: Circle): boolean {
  const distance = c1.center.distance(c2.center);
  return distance < (c1.radius + c2.radius - 1);
}

export function circleIntersect(c1: Circle, c2: Circle): Point[] {

  const {
    x: x1,
    y: y1,
    radius: r1
  } = c1;

  const {
    x: x2,
    y: y2,
    radius: r2
  } = c2;

  var centerdx = x1 - x2;
  var centerdy = y1 - y2;
  var R = Math.sqrt(centerdx * centerdx + centerdy * centerdy);
  if (!(Math.abs(r1 - r2) <= R && R <= r1 + r2)) { // no intersection
    return []; // empty list of results
  }

  var R2 = R*R;
  var R4 = R2*R2;
  var a = (r1*r1 - r2*r2) / (2 * R2);
  var r2r2 = (r1*r1 - r2*r2);
  var c = Math.sqrt(2 * (r1*r1 + r2*r2) / R2 - (r2r2 * r2r2) / R4 - 1);

  var fx = (x1+x2) / 2 + a * (x2 - x1);
  var gx = c * (y2 - y1) / 2;
  var ix1 = fx + gx;
  var ix2 = fx - gx;

  var fy = (y1+y2) / 2 + a * (y2 - y1);
  var gy = c * (x1 - x2) / 2;
  var iy1 = fy + gy;
  var iy2 = fy - gy;

  const p1 = new Point(ix1, iy1);
  const p2 = new Point(ix2, iy2);

  return [p1, p2];
}
